import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { QCS_LOGIN_URL } from '../../../configs'
import { applyBrandTheme } from '../../../constants/qcsTheme'
import { setBrowserTabTitle } from '../../../helpers/setBrowserTabTitle'
import { getHandoffErrorMessage } from '../helpers/qcsHandoffError'

const QCS_LOGO_SRC = `${process.env.PUBLIC_URL || ''}/images/platform/qcs-logo.svg`

export const styles = () => ({
  page: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
  },
  topBar: {
    flex: '0 0 64px',
    height: 64,
    backgroundColor: '#104146',
  },
  main: {
    flex: '1 0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
  },
  content: {
    width: '100%',
    maxWidth: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    '@media (min-width: 768px)': {
      maxWidth: 560,
    },
  },
  logo: {
    width: 82,
    height: 82,
    display: 'block',
    marginBottom: 16,
  },
  message: {
    margin: '0 0 20px',
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 400,
    textAlign: 'center',
    color: '#103C56',
    '@media (min-width: 768px)': {
      whiteSpace: 'nowrap',
    },
  },
  button: {
    boxSizing: 'border-box',
    width: 160,
    height: 48,
    padding: '0 16px',
    borderRadius: 28,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#0F4146',
    color: '#FFFFFF',
    fontSize: 18,
    lineHeight: '24px',
    fontWeight: 600,
    textDecoration: 'none',
    '&:hover, &:focus': {
      color: '#FFFFFF',
      textDecoration: 'none',
    },
  },
})

const QcsHandoffErrorPage = ({ classes, location }) => {
  const message = getHandoffErrorMessage(location && location.search)

  useEffect(() => {
    setBrowserTabTitle('QCS')
    applyBrandTheme(true)
    return () => applyBrandTheme(false)
  }, [])

  return (
    <div className={classes.page}>
      <header className={classes.topBar} />

      <main className={classes.main}>
        <section className={classes.content}>
          <img className={classes.logo} src={QCS_LOGO_SRC} alt="QCS" width={82} height={82} />
          <p className={classes.message}>{message}</p>
          <a className={classes.button} href={QCS_LOGIN_URL}>
            Return to QCS
          </a>
        </section>
      </main>
    </div>
  )
}

QcsHandoffErrorPage.propTypes = {
  classes: PropTypes.object.isRequired,
  location: PropTypes.object,
}

export default withStyles(styles)(QcsHandoffErrorPage)
